
import '../Styles/Footer.css'
import PhoneNumber from './PhoneNumber';
import logo from '../Logo.png'
function Footer(params) {
    return (
        <div className="Footer">
            <div className='footerContainer'>

                <div className="footerContactContainer">
                    <h2>Contact Us</h2>
                    <div>
                        <h3>Email:</h3>
                        <a href="mailto:tawnee.anderson@andersonstaxes.com">Tawnee.anderson@andersonstaxes.com</a>
                    </div>
                    <PhoneNumber />
                    
                        <div>
                            <h3>Local Office:</h3>
                            <a href="https://maps.app.goo.gl/RNBRsf2pprLWsCcF8" target="_blank">185 North 200 West<br /> Ephraim, Utah 84627</a>
                           
                        </div>
                        <div>
                            <h3>Business Office:</h3>
                           <a href="https://maps.app.goo.gl/PetMGSy3UQRgswdP8" target="_blank">3796 Renata Dr<br /> Brownsville, TX 78521</a>
                            
                        </div>
                    

                </div>
                <div>
                    <h2>External Resources</h2>
                    <h3>
                        <a href="https://www.irs.gov" target="_blank">Irs.gov</a>
                    </h3>
                    <h3>
                        <a href="https://www.irs.gov/refunds" target="_blank">Track your return</a>
                    </h3>
                    <h3>
                        <a href="https://www.irs.gov/help/irs2goapp" target="_blank">Track my refund</a>
                    </h3>
                    <h3>
                        <a href=" https://www.nerdwallet.com/article/taxes/federal-income-tax-brackets" target="_blank">
                            Tax income bracket</a>
                    </h3>
                </div>
            </div>
            <h1>
                <a href='/' >
                    <img src={logo} className="Logo" alt="Anderson Taxes Logo" />
                    Anderson's Taxes
                </a>
            </h1>

        </div>
    )
}

export default Footer;